import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  Card,
  Icon,
  Input,
  UploadWrapper,
} from '../../components';
import { Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fixImgPath, getProjectLogo } from '../../utils/helpers';
import { getInvitations } from '../Dashboard/actions';
import { updateUser, updateUserAvatar, changePassword } from '../Login/actions';
import { acceptInvitation, declineInvitation } from '../Project/actions';
import { Divider, Space, Tag } from 'antd';
import { API_INTEREST_LIST } from '../../config/API';

import axios from '../../config/axios';

const { CheckableTag } = Tag;

const Settings = () => {
  const [uploadedImage, setUploadedImage] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [currentPwd, setCurrentPwd] = React.useState('');
  const [newPwd, setNewPwd] = React.useState('');
  const [confirmPwd, setConfirmPwd] = React.useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const user = useSelector((s) => s.auth.user);
  const invitations = useSelector((s) => s.dashboard.invitations);
  const dispatch = useDispatch();

  const [interests, setInterests] = useState([]);

  React.useEffect(() => {
    dispatch(getInvitations());
  }, []);

  React.useEffect(() => {
    setFirstName(user.data.firstName);
    setLastName(user.data.lastName);
    setSelectedTags(user.data.interests);
    setUploadedImage(user.data.avatar);
  }, [user.data]);

  const uploadLogo = React.useCallback((val) => {
    const preview = URL.createObjectURL(val);
    setUploadedImage(preview);
    const formData = new FormData();
    formData.append('avatar', val);
    dispatch(updateUserAvatar({ preview, formData }));
  }, []);

  const updateData = React.useCallback(() => {
    dispatch(
      updateUser({
        firstName,
        lastName,
        interests: selectedTags || null,
      })
    );
  }, [firstName, lastName, selectedTags]);

  const updatePassword = React.useCallback(() => {
    try {
      dispatch(
        changePassword({
          password: currentPwd,
          newPassword: newPwd,
          confirmPassword: confirmPwd,
        })
      );
    } catch (e) {
      console.log(e);
    }
  }, [currentPwd, newPwd, confirmPwd]);

  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter((t) => t !== tag);
    console.log('You are interested in: ', nextSelectedTags);
    nextSelectedTags.length < 1
      ? setSelectedTags([])
      : setSelectedTags(nextSelectedTags);
  };
  useEffect(() => {
    axios
      .get(API_INTEREST_LIST)
      .then((response) => {
        setInterests(response.data.interests);
      })
      .catch((error) => {
        console.log(error, 'error');
      });
  }, []);

  return (
    <div>
      <div className="heading">
        <h1>Woosla</h1>
        <h4>Settings</h4>
      </div>
      <Row gutter={[20, 20]}>
        <Col xs={24} md={12}>
          <Card>
            <div className="imgContainer">
              <UploadWrapper onChange={uploadLogo} onlyImg>
                <Avatar
                  src={fixImgPath(uploadedImage)}
                  name={firstName}
                  size={70}
                />
              </UploadWrapper>
            </div>
            <Input
              value={firstName}
              onChange={setFirstName}
              placeholder="First name"
            />
            <Input
              value={lastName}
              onChange={setLastName}
              placeholder="Last name"
            />
            <Input value={user.data.email} placeholder="Email" disabled />
            <Input value={user.data.phone} placeholder="Phone" disabled />
            <Divider orientation="left">Interests</Divider>
            <Space size={[0, 8]} wrap>
              {interests.map((tag) => (
                <CheckableTag
                  key={tag}
                  checked={selectedTags.includes(tag)}
                  onChange={(checked) => handleChange(tag, checked)}
                >
                  {tag}
                </CheckableTag>
              ))}
            </Space>
            <br />
            <br />
            <Button
              onClick={updateData}
              loading={user.loading}
              disabled={!firstName || !lastName}
            >
              Update
            </Button>
          </Card>
        </Col>
        {invitations.data.length > 0 ? (
          <Col xs={24} md={12}>
            <Card
              title="Invitations"
              height={268}
              overflow="scroll"
              loading={invitations.loading}
              empty={!invitations.data.length}
            >
              {invitations.data.map((item) => (
                <div key={item._id} className="listItem invitation">
                  <Row gutter={10} justify="middle">
                    <Col>
                      <Avatar
                        src={getProjectLogo(item.project?.image)}
                        name={item.project?.name}
                      />
                    </Col>
                    <Col>{item.project?.name}</Col>
                  </Row>
                  <Row>
                    <div onClick={() => dispatch(acceptInvitation(item._id))}>
                      <Icon name="chevron-up success" />
                    </div>
                    <div onClick={() => dispatch(declineInvitation(item._id))}>
                      <Icon name="close danger" />
                    </div>
                  </Row>
                </div>
              ))}
            </Card>
          </Col>
        ) : null}
        <Col xs={24} md={12}>
          <Card title="Change Password">
            <Input
              value={currentPwd}
              onChange={setCurrentPwd}
              placeholder="Current password"
              type={'password'}
            />
            <Input
              value={newPwd}
              onChange={setNewPwd}
              placeholder="New Password"
              type={'password'}
            />
            <Input
              value={confirmPwd}
              onChange={setConfirmPwd}
              placeholder="Confirm Password"
              type={'password'}
            />
            <br />
            <br />
            <Button
              onClick={updatePassword}
              loading={user.loading}
              disabled={!currentPwd || !newPwd}
            >
              Update
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Settings;
